import api from './api';

const TIPOS_REFERENCIA = new Set(['card', 'atividade']);

export const criarAnotacao = async ({ refType, refId, text }) => {
    const texto = String(text || '').trim();
    const id = Number(refId);

    if (!texto) return null;
    if (!TIPOS_REFERENCIA.has(refType)) {
        throw new Error(`Tipo de referência de anotação inválido: ${refType}`);
    }
    if (!Number.isInteger(id) || id <= 0) {
        throw new Error('A anotação precisa estar vinculada a um registro válido.');
    }

    const { data } = await api.post('/comercial/anotacoes', {
        refType,
        refId: id,
        text: texto,
    });

    return data;
};

